var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoneRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 45,
    viewBox: "0 0 30 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_812)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_178_812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75391 2.50391C14.1398 2.69675 22.4998 11.1755 22.5 21.6074C22.5 32.0395 14.1399 40.5171 3.75391 40.71C3.72158 40.471 3.69109 40.116 3.66504 39.6475C3.61051 38.6663 3.57332 37.2389 3.54883 35.4658C3.49987 31.9218 3.5 27.0234 3.5 21.6074C3.5 16.1916 3.49987 11.2939 3.54883 7.75C3.57332 5.97689 3.61051 4.54953 3.66504 3.56836C3.69115 3.09858 3.72148 2.74294 3.75391 2.50391Z",
    stroke: "url(#paint0_linear_178_812)",
    strokeOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_178_812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6959 22.6959C27.6959 25.9671 27.5081 26 24.2369 26C24 26 24 25.9671 24 22.6959C24 19.4248 24 19 24.2369 19C27.6959 19 27.6959 19.4248 27.6959 22.6959Z",
    fill: "#D41A90",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.75391 2.50391C14.1398 2.69675 22.4998 11.1755 22.5 21.6074C22.5 32.0395 14.1399 40.5171 3.75391 40.71C3.72158 40.471 3.69109 40.116 3.66504 39.6475C3.61051 38.6663 3.57332 37.2389 3.54883 35.4658C3.49987 31.9218 3.5 27.0234 3.5 21.6074C3.5 16.1916 3.49987 11.2939 3.54883 7.75C3.57332 5.97689 3.61051 4.54953 3.66504 3.56836C3.69115 3.09858 3.72148 2.74294 3.75391 2.50391Z",
    stroke: "url(#paint1_linear_178_812)",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6959 22.6959C27.6959 25.9671 27.5081 26 24.2369 26C24 26 24 25.9671 24 22.6959C24 19.4248 24 19 24.2369 19C27.6959 19 27.6959 19.4248 27.6959 22.6959Z",
    fill: "#D41A90",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_178_812",
    x: -1,
    y: -2,
    width: 28,
    height: 47.2156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_178_812"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_178_812",
    x: 20,
    y: 15,
    width: 11.6958,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_178_812"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_178_812",
    x1: 2.66292,
    y1: 24.2872,
    x2: 23.4122,
    y2: 24.2641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#1655DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D51A90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_178_812",
    x1: 2.66292,
    y1: 24.2872,
    x2: 23.4122,
    y2: 24.2641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#1655DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D51A90"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoneRight);
export default __webpack_public_path__ + "static/media/foneRight.4e786f7ce14e9012565c86f4176f7b83.svg";
export { ForwardRef as ReactComponent };